import { createSelector } from 'reselect';

import { selectSelectedCartItems } from './selectSelectedCartItems';

export const selectCanCheckout = createSelector(
    [selectSelectedCartItems],
    (items) => items.length > 0,
);
